import { render } from "./ServiceTypeFilter.vue?vue&type=template&id=ff58a0c8"
import script from "./ServiceTypeFilter.vue?vue&type=script&lang=js"
export * from "./ServiceTypeFilter.vue?vue&type=script&lang=js"

import "./ServiceTypeFilter.vue?vue&type=style&index=0&id=ff58a0c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__